import api from 'api';
import { appsignalSendError } from 'lib/appsignal';

import type { ErrorInfo } from 'react';
import type { User } from 'shared-types';

interface Params {
  error?: Error;
  errorInfo?: ErrorInfo;
  statusCode?: number;
  user?: Pick<User, 'id' | 'roles'>;
}

const sendErrorInfoToApi = async ({
  error,
  errorInfo,
  statusCode,
  user
}: Params) => {
  try {
    if (process.env.NODE_ENV === 'production' && error) {
      appsignalSendError('SendErrorInfoToApi', error, {
        errorInfo,
        ...(user ? { user } : {})
      });

      await api.post('/admin/error', {
        error,
        errorInfo,
        href: typeof window !== 'undefined' ? window.location.href : '',
        statusCode,
        userAgent:
          typeof window !== 'undefined' ? window.navigator.userAgent : ''
      });
    }
  } catch {
    console.error('error in sending error info to api');
  }
};

export default sendErrorInfoToApi;
